import { zodResolver } from '@hookform/resolvers/zod';
import { useController, useForm } from 'react-hook-form';
import { useTranslation } from '../../../../../../../../translation/TranslationContext';
import {
  CatalogAccessChangeDatesFormValues,
  buildCatalogAccessChangeDatesSchema,
} from '../catalogAccessChangeDates.schema';
import { CatalogAccessDates } from '../catalogAccessSection.types';

interface UseCatalogAccessChangeDatesModalParams {
  onConfirm: (dates: CatalogAccessDates) => void;
}

export const useCatalogAccessChangeDatesModal = ({
  onConfirm,
}: UseCatalogAccessChangeDatesModalParams) => {
  const { translate } = useTranslation();

  const { control, handleSubmit } = useForm<CatalogAccessChangeDatesFormValues>({
    resolver: zodResolver(buildCatalogAccessChangeDatesSchema(translate)),
    defaultValues: { startDate: null, endDate: null },
    mode: 'onBlur',
  });

  const startDate = useController({ control, name: 'startDate' });
  const endDate = useController({ control, name: 'endDate' });

  return { startDate, endDate, handleConfirm: handleSubmit(onConfirm) };
};
